import { Injectable } from '@angular/core';
import { BaseController, Params } from '@common/modules/base/base.controller';  
import { FrotaContratadaModel } from '@data/contrato/models';
import { ContratoRepository } from '@data/contrato/contrato.repository';

@Injectable()
export class FrotaContratadaController extends BaseController<FrotaContratadaModel> {
  constructor(private contratoRepository: ContratoRepository) {
    super(contratoRepository);
  }

  override getPaginated(params: Params) {
    return this.contratoRepository.getFrotaContratada(params);
  }
}
